export enum MyFieldsModals {
	NO_MODAL = 0,
	REGISTER_FIELD = 1,
	REGISTER_LOT = 2
}
